import React from 'react';
import bottomRightMenu from '../../Images/Menus/BottomRightMenu.png';

class ModeTab extends React.Component {
  render() {
    return (
      <div className="bottomRightSection">
        <h1 className="bottomRightText">{this.props.mode}</h1>
        <img src={bottomRightMenu} alt="modeFrame" className="bottomRightFrame"/>
      </div>
    );
  }
}

export default ModeTab;



// WEBPACK FOOTER //
// ./src/Components/ModeTab/ModeTab.js